import React, {PureComponent} from 'react';
import {connect} from 'dva';
import {Cascader, Button} from 'antd';
import {injectIntl, FormattedMessage} from 'react-intl';
import ChangePwd from './ChangePwd';
import './index.less';
import {SEMICOLON, USER_FROM} from "../../utils/constants";

class PersonalSetting extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedZoneIds: [],
      initFlag: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const {zone, userInfo} = nextProps;
    const {commonZoneIds} = userInfo;
    const {initFlag} = this.state;
    if (zone && commonZoneIds && !initFlag) {
      this.setState({selectedZoneIds: commonZoneIds ? commonZoneIds.split(SEMICOLON) : []})
    }
  }

  render() {
    const {zone, userInfo = {}, intl} = this.props;

    const zoneOptions = this.organizeOptions(zone);
    const {selectedZoneIds} = this.state;

    return <div className="personal-setting">
      <div className="card-title">
        <FormattedMessage id="personal_addr_config"/>
      </div>
      <div className="setting-info">
        <div className="setting-item">
          <FormattedMessage id="personal_common_addr"/>
          <Cascader placeholder={intl.formatMessage({id: 'pls_select'})}
                    options={zoneOptions ? zoneOptions.children : []} value={selectedZoneIds} onChange={(value) => {
            this.setState({selectedZoneIds: value});
          }}/>
        </div>
        <Button type="primary" onClick={this.saveCommonZone}><FormattedMessage id="btn_save"/></Button>
      </div>
      <ChangePwd dispatch={this.props.dispatch} userInfo={userInfo}/>
    </div>
  }

  saveCommonZone = () => {
    const {dispatch} = this.props;
    const {selectedZoneIds} = this.state;
    dispatch({
      type: "personal/saveCommonZone",
      commonZoneIds: selectedZoneIds.join(SEMICOLON)
    });
  };

  //根据zone数据生成级联选择的options
  organizeOptions = zone => {
    if (!zone || !zone.id) {
      return null;
    }
    const option = {};
    option.value = String(zone.id);
    option.label = zone.name;
    if (zone.child.length > 0) {
      option.children = [];
    }
    for (let child of zone.child) {
      const childOption = this.organizeOptions(child);
      if (childOption) {
        option.children.push(childOption);
      }
    }
    return option;
  };
}

const mapStateToProps = state => {
  return {
    zone: state.roomZone.zone,
    userInfo: state.login.userInfo
  };
};

export default connect(mapStateToProps)(injectIntl(PersonalSetting));




// WEBPACK FOOTER //
// ./src/routes/Personal/PersonalSetting.js